export default function horizontalScroll( parentElement ) {
	if ( !$.fn.hScroll ) {
		// horizontal scroll
		$.fn.hScroll = function( amount ) {
			const $target = $( this );
			amount = amount || 120;
			// eslint-disable-next-line complexity
			function horizontalScroll( event ) {
				const $eventTraget = $( event.target );
				const originalEvent = event.originalEvent;
				const direction = originalEvent.detail ? originalEvent.detail * -amount : originalEvent.wheelDelta;
				let position = $target.scrollLeft();
				position += direction > 0 ? -amount : amount;
				position = position < 0 ? 0 : position;
				let isTargetScrollbarOuter = $eventTraget.hasClass( "scrollbar-outer" ) || $eventTraget.closest( ".scrollbar-outer" ).length;

				if ( isTargetScrollbarOuter || position < 0 || !( $target[0].scrollWidth > $target[0].clientWidth ) ) {return;}
				event.preventDefault();
				$target.scrollLeft( position );
			}

			if ( $target[0].scrollWidth > $target[0].clientWidth ) {
				$target.on( "DOMMouseScroll mousewheel", horizontalScroll );
			}
		};
	}

	if ( parentElement ) {
		$( parentElement ).find( ".js-horizontal-scroll" ).each( function() {
			$( this ).hScroll( 60 );
		} );
	}
}

